import { useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import DoletasBalanceCard from "./DoletasBalanceCard";
import DoletasActions from "./DoletasActions";
import DoletasGalaInfo from "./DoletasGalaInfo";
import DoletasTicketShop from "./DoletasTicketShop";
import DoletasHistory from "./DoletasHistory";

export default function ClientDoletasCard() {
  var balanceState = useState(null);
  var txState = useState([]);
  var loadingState = useState(true);

  var fetchData = useCallback(async function () {
    try {
      var bRes = await api.get("/doletas/my-balance");
      balanceState[1](bRes.data);
      if (bRes.data.enabled) {
        var tRes = await api.get("/doletas/my-transactions?limit=10");
        txState[1](tRes.data.transactions || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      loadingState[1](false);
    }
  }, []);

  useEffect(function () { fetchData(); }, [fetchData]);

  if (loadingState[0]) return null;
  var data = balanceState[0];
  if (!data || !data.enabled) return null;

  return (
    <div className="mb-6 lg:mb-8" data-testid="client-doletas-section">
      <DoletasBalanceCard data={data}>
        <DoletasActions doletasPerReal={data.doletas_per_real} onRefresh={fetchData} />
      </DoletasBalanceCard>
      <div className="mt-4">
        <DoletasGalaInfo galaEvent={data.gala_event} />
      </div>
      <DoletasTicketShop eligible={data.gala_eligible} />
      <DoletasHistory transactions={txState[0]} />
    </div>
  );
}
